<template>
    <div id="App">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {};
    },
    created() {
        // 微信小程序webview环境下不拦截popstate，避免产生多余历史记录影响小程序返回按钮
        if (!window.__wxjs_environment) {
            history.pushState(null, null, document.URL);
            window.addEventListener('popstate', function () {
                history.pushState(null, null, document.URL);
            });
        }
    },
    mounted() {},
    //页面销毁前解除监听
    destroyed() {
        window.removeEventListener('popstate', e => this.beforeunloadHandler(e));
    },
    components: {},
};
</script>

<style lang="scss">
@import './static/scss/base/vant-extensions';
@import './static/scss/base/main';

html,
body {
    background-color: var(--el-bg-color-page);
}
.flex-start {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
}
#App {
    height: 100%;
    /*修改滚动条*/
    // .scroll {
    //     scrollbar-color: #f0f0f0;
    //     /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
    //     scrollbar-width: thin;
    //     /* 火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细 */
    //     -ms-overflow-style: none;
    // }

    // ::-webkit-scrollbar {
    //     //     // width: 12px; //这是竖向滚动条的宽度。如果是横向滚动条则设置height
    //     height: 10px;
    // }
    // ::-webkit-scrollbar-thumb {
    //     border-radius: 2px;
    //     background: var(--el-border-color-light) !important;
    // }
    // ::-webkit-scrollbar-track {
    //     width: 5px !important; //这是竖向滚动条的宽度。如果是横向滚动条则设置height
    //     background: #f0f0f0;
    //     border-radius: 3px;
    // }
    /*修改滚动条结束*/
}
body .el-card .el-card__header span.title {
    font-size: 16px;
    font-weight: bold;
    line-height: 32px;
    display: inline-block;
}
.m-b {
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue